<template>
  <div class="Reports__View">
    <EntityListLayout v-if="tabs.length" :tabs="tabs" ref="entity" @onNewEntitySave="onNewEntitySave">
      <template #title>קבוצות</template>
      <template #button>
        <a @click="addGroup" class="link-button">
          הוספת קבוצה
        </a>
      </template>
      <template v-slot:counter="slotProps">
        סה"כ <b>{{ getTotalRecords(slotProps) }} </b>
      </template>
    </EntityListLayout>
  </div>
</template>
<script>
import LessonService from "@/services/LessonService";
import EntityListLayout from "@/components/EntityListLayout.vue";
import GroupEntity from "@/views/GroupEntity.vue";
import DialogAddGroup from '@/components/DialogAddGroup.vue';
import {
  ModalProgrammatic as Modal,
} from 'buefy';
import TableActions from "@/services/TableActionsService";
import FieldService from "@/services/FieldService";
import FilterService from "../services/FilterService";

export default {
  name: "Reports",
  data() {
    return {
      tabs: [],
    };
  },
  components: {
    EntityListLayout,
  },
  computed: {
    courseId() {
      return this.$store.state.auth.course.id;
    },
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      const lessonsFields = FieldService.list("groups");
      const groupfilters = FilterService.list();

      const sideViewEntity = {
        component: GroupEntity,
        preview: true,
        readOnly: !this.isAdmin,
        title: "פרטי קבוצה",
        recordUrl: "group",
        recordTitle: "הצג קבוצה"
      };
      const fields = [
        { ...lessonsFields.Id, checked: true },
        { ...lessonsFields.Name, checked: true },
        { ...lessonsFields.GroupStudentsCount, checked: true },
        { ...lessonsFields.GroupLessonsCount, checked: true },
        { ...lessonsFields.CreateDate, checked: true },
        { ...lessonsFields.Entity, checked: true },
      ];

      this.tabs = [
        {
          id: "AllGroups",
          isPrimary: true,
          title: "כל הקבוצות",
          getDataAsync: this.getGroups,
          perPage: 100,
          fields,
          sortField: "Id",
          sortOrder: "desc",
          checkableRows: true,
          fastSearch: true,
          fastSearchOptions: {
            propName: "Terms",
            label: "חיפוש קבוצה",
          },
          filters: [
          { ...groupfilters.Users, selected: this.$route.params.UserIds },
          ],
          sideViewEntity,
          tableActions: (() => {
            let actions = [TableActions.deleteGroups, TableActions.assignGroupsToLessons, TableActions.assignGroupsToStudents, TableActions.assignEscortsToStudents];
            if (this.isAdmin) {
              actions = actions.concat([
                {
                  ...TableActions.changeTransferStatusCompany,
                  Label: "שינוי סטטוס הסבת חברה",
                },
                {
                  ...TableActions.changeTransferStatusDriver,
                  Label: "שינוי סטטוס הסבת נהג",
                },
                TableActions.changeReportStatus,
              ]);
              if (this.isUserProfile) {
                actions = actions.concat([TableActions.removeFromProfile]);
              }
            }
            return actions;
          })(),
        },
      ];
    },
    addGroup() {
      Modal.open({
        component: DialogAddGroup,
        props: {
          store: this.$store
        },
        canCancel: false,
        hasModalCard: true,
        trapFocus: true,
      });
    },
    onNewEntitySave() {
      this.$refs.entity.onNewEntityCancel();
    },
    getGroups({ ...rest }) {
      return LessonService.getGroups(this.courseId, rest).then((r) => ({
        data: {
          TotalResults: r.data.totalResults,
          Items: r.data.items,
        },
      }));
    },
    getTotalRecords(slotProps) {
      return slotProps.tab && slotProps.tab.total && slotProps.tab.total;
    },
  },
};
</script>
<style scoped lang="scss">
.link-button {
  background: #00427e;
  border: none;
  border-radius: 3px;
  padding: 14px 25px;
  color: white;
  cursor: pointer;
}
</style>
